import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-quality-dialog',
  standalone: false,
  templateUrl: './confirm-quality-dialog.component.html',
})
export class ConfirmQualityDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmQualityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmQualityDialogData,
  ) {}
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}

export interface ConfirmQualityDialogData {
  title: string;
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
}
